import { h } from '@stencil/core';
import { EQdsButtonSize, EQdsButtonImportance, getQdsIconLibrary, isLinkTypeOnline, isTargetBlank } from '@pes-ui/utils';
import { onDownloadLinkClickGA, onSoftwareDocumentDialogClick, getPriorityNumber } from '../helper';
const provideQdsButtonAttributes = (numberOfButtonsBefore) => {
  const n = numberOfButtonsBefore;
  let attr;
  switch (n) {
    case 0:
      attr = { size: EQdsButtonSize.LARGE, importance: EQdsButtonImportance.EMPHASIZED };
      break;
    case 1:
      attr = { size: EQdsButtonSize.LARGE, importance: EQdsButtonImportance.STANDARD };
      break;
    default:
      attr = { size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.SUBDUED };
  }
  return attr;
};
export const SoftwareDownloadArea = ({ data, numberOfButtonsBefore = 0, className, ctaItem, position, }) => {
  const { labels, additionLinks } = data;
  if (additionLinks.length === 0)
    return;
  const isSubduedImportance = numberOfButtonsBefore === 2;
  if (additionLinks.length === 1) {
    const { url, type, target, reference, fileName, docType } = additionLinks[0];
    const attr = isTargetBlank(target) ? { target: '_blank' } : { download: '' };
    let icon;
    if (isLinkTypeOnline(type)) {
      icon = "arrow-top-right-on-square";
    }
    else if (isSubduedImportance) {
      icon = "arrow-down-tray";
    }
    return (h("qds-button", Object.assign({ class: className, href: url }, attr, provideQdsButtonAttributes(numberOfButtonsBefore), { onClick: () => onDownloadLinkClickGA(additionLinks[0], ctaItem, position), "data-da-element-id": "download_if", "data-da-priority": getPriorityNumber(numberOfButtonsBefore), "data-doc-reference": reference, "data-doc-name": fileName, "data-doc-type": docType, text: isLinkTypeOnline(type) ? labels.onlineLabel : labels.offlineLabel, iconName: icon, iconLibrary: getQdsIconLibrary(icon), variant: "hero" })));
  }
  const icon = isSubduedImportance ? "square-behind-another" : '';
  return (h("qds-button", Object.assign({ class: className }, provideQdsButtonAttributes(numberOfButtonsBefore), { onClick: () => onSoftwareDocumentDialogClick(additionLinks[0].type, additionLinks, labels, ctaItem, position), "data-da-element-id": "download_if", "data-da-priority": getPriorityNumber(numberOfButtonsBefore), text: labels.areaLabel, iconName: icon, iconLibrary: getQdsIconLibrary(icon), variant: "hero" })));
};
